// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Xk9B0sUc7x0DsTxYSOb6Yw\\=\\={display:none;font:normal 15px/29px Geomanist}", "",{"version":3,"sources":["webpack://./resources/js/Components/SwitchAccount/SwitchAccount.module.css"],"names":[],"mappings":"AAAA,4BAEI,YAAa,CADb,+BAEJ","sourcesContent":[".label {\n    font: normal 15px/29px Geomanist;\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "Xk9B0sUc7x0DsTxYSOb6Yw=="
};
export default ___CSS_LOADER_EXPORT___;
